import React from "react";

import "./AudioPlayer.css";

import Constantes from "Projects/CC_cubi_clan_project/Utils/Constantes";

export class AudioPlayer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showAudioPlayer: false,
      audioUrl: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.showAudioPlayer !== prevProps.showAudioPlayer) {
      this.setState({ showAudioPlayer: this.props.showAudioPlayer });
    }
    if (this.props.audioUrl !== prevProps.audioUrl) {
      let url = Constantes.URL_BASE + Constantes.URL_BOX + "stream";
      url = this.props.audioUrl
        ? url + "?FileName=" + this.props.audioUrl
        : null;
      this.setState({ audioUrl: url });
      this.crearReproductor(url);
    }
  }

  crearReproductor(src){
    const audioElement = document.createElement('audio');
    audioElement.controls = true;
    audioElement.src = src;
    audioElement.autoplay = true;

    const divElement = document.getElementById('reproductor-audio');

    while (divElement && divElement.firstChild) {
      divElement.removeChild(divElement.firstChild);
    }

    if (divElement) {
      divElement.appendChild(audioElement);
    }
  }

  toggleShow = () => {
    this.setState({
      showAudioPlayer: !this.state.showAudioPlayer,
    });
    this.props.closeAudioPlayer();
  };

  render() {
    return (
      <div id="reproductor-audio">
      </div>
    );
  }
}
